// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
// import ChevronRight from "@insite/mobius/Icons/ChevronRight"; // Store Custom Code
// import Link from "@insite/mobius/Link"; // Starter Custom Code
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
// import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading"; // Store Custom Code
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { spacingStyles } from "@toolkit/Themes/common/mixins";

/* Store Custom Code - Start */
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
/* Store Custom Code - End */

export interface CardListHeadingStyles {
    heading?: HeadingPresentationProps;
    link?: LinkPresentationProps;
}

export const cardListHeadingStyles: CardListHeadingStyles = {
    heading: {
        variant: "h4",
        forwardAs: "h2",
        itemOffset: 0.3,
        extendedStyles: {
            title: {
                css: css`
                    ${spacingStyles(null, "0.75em")}
                    padding-bottom: 0.6em;
                    border-bottom: 1px solid ${getColor("common.border")};
                `,
            },
        },
    },
    link: linkGetActionLinkProps(ChevronRight, "right"), // Store Custom Code
};
/* Starter Custom Code - End */

interface OwnProps {
    heading: JSX.Element | string; // Store Custom Code
    viewAllUrl?: string;
    // Starter Custom Code
    hasNoResults?: boolean;
    extendedStyles?: CardListHeadingStyles;
    overridedStyles?: CardListHeadingStyles;
    // Store Custom Code
    viewAllText?: string;
}

type Props = OwnProps & React.HTMLAttributes<HTMLElement>; // Starter Custom Code

const CardListHeading: React.FunctionComponent<Props /* Starter Custom Code */> = ({
    heading,
    viewAllUrl,
    // Starter Custom Code
    hasNoResults,
    extendedStyles,
    overridedStyles,
    children,
    /* Store Custom Code - Start */
    viewAllText,
    /* Store Custom Code - End */
    ...htmlAttributes
}) => {
    /* Starter Custom Code - Start */
    const styles = useExpandProps(cardListHeadingStyles, extendedStyles, overridedStyles);

    const headingStyles = React.useMemo(() => {
        if (hasNoResults) {
            return styles.heading;
        }

        return mergeProps<CardListHeadingStyles["heading"]>(styles.heading, {
            extendedStyles: {
                title: {
                    css: css`
                        margin: 0;
                        border-bottom: 0;
                    `,
                },
                /* Store Custom Code - Start */
                flexWrapper: {
                    extendedStyles: {
                        content: {
                            css: css`
                                align-items: center !important;
                            `,
                        },
                    },
                },
                /* Store Custom Code - End */
            },
        });
    }, [styles.heading, hasNoResults]);

    return (
        <Heading title={heading} {...headingStyles} className="card-list-heading" {...htmlAttributes}>
            {children}
            {viewAllUrl && (
                <Link
                    href={viewAllUrl}
                    // Store Removed - icon
                    {...styles.link}
                    className="view-all-link"
                    data-test-selector="cardListHeadingViewAllLink"
                >
                    {translate(viewAllText || "View All") /* Store Custom Code */}
                    <VisuallyHidden>{heading}</VisuallyHidden>
                </Link>
            )}
        </Heading>
    );
    /* Starter Custom Code - End */
};

export default CardListHeading;
